<template>
  <main class="checkin-page">
    <section class="checkin-shell">
      <header class="checkin-header">
        <span class="checkin-logo"><img src="/zaturdayicon.png" alt="Zaturday" /></span>
        <span><h1>Meeting Check In</h1><small>Confirm your attendance</small></span>
      </header>

      <v-card class="checkin-card" flat>
        <div class="checkin-card-title"><v-icon color="#00378e" size="28">mdi-calendar-check</v-icon><h2>Check In</h2></div>

        <v-card-text v-if="MeetingLoaded" class="checkin-content">
          <div class="meeting-details">
            <article><span>Booking Name</span><strong>{{ BookingName }}</strong></article>
            <article><span>Room</span><strong>{{ RoomName }}</strong></article>
            <article><span>Date / Time</span><strong>{{ DateTime }}</strong></article>
            <article><span>Host Name</span><strong>{{ HostName }}</strong></article>
          </div>

          <div v-if="RequiresOtp && CheckInStatus !== true" class="otp-section">
            <label for="checkin-otp">Enter the 6-digit OTP sent to your email</label>
            <v-text-field
              id="checkin-otp"
              ref="otpInput"
              :value="Otp"
              inputmode="numeric"
              autocomplete="one-time-code"
              maxlength="6"
              outlined
              hide-details
              class="otp-input"
              aria-label="Check-in OTP"
              @input="updateOtp"
              @keyup.enter="checkInMeeting"
            />
          </div>

          <v-btn
            class="checkin-button"
            color="#00378e"
            depressed
            :loading="LoadingDialog"
            :disabled="LoadingDialog || CheckInStatus === true || (RequiresOtp && Otp.length !== 6)"
            @click="checkInMeeting()"
          >
            <v-icon left size="21">{{ CheckInStatus === true ? "mdi-check-circle" : "mdi-login" }}</v-icon>
            {{ CheckInStatus === true ? "Checked In" : "Check In" }}
          </v-btn>
        </v-card-text>

        <v-card-text v-else class="checkin-empty" aria-live="polite">
          <v-icon size="56" color="#00378e">mdi-calendar-search</v-icon>
          <strong>{{ EmptyMessage }}</strong>
        </v-card-text>
      </v-card>
    </section>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card class="pa-6 d-flex flex-column align-center justify-center" elevation="8" rounded="xl">
        <v-progress-circular indeterminate color="#00378e" size="70" width="6"></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium">Loading, please wait...</span>
      </v-card>
    </v-dialog>
  </main>
</template>

<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "CheckinMeeting",
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      BookingName: "",
      RoomName: "",
      DateTime: "",
      HostName: "",
      CheckInStatus: "",
      RequiresOtp: false,
      Otp: "",
      EventID: "",
      MeetingLoaded: false,
      EmptyMessage: "Loading meeting...",
    };
  },

  async mounted() {
    let self = this;
    self.EventID = self.$route.params.eventID || "";
    if (self.EventID) {
      self.getDataMeetingForCheckIn(self.EventID);
    } else {
      self.EmptyMessage = "Meeting not found.";
    }
  },

  methods: {
    getDataMeetingForCheckIn(eventID) {
      let self = this;
      let temp = {
        eventID: eventID,
      };
      self.LoadingDialog = true;
      axios
        .post(`${self.url}Calendar/getDataMeetingForCheckInOffice365ByEventID`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.BookingName = response.data.data.bookingName;
            self.HostName = response.data.data.hostName;
            self.DateTime = self.ChangeFormatDate(response.data.data.startDate) + " - " + self.ChangeFormatDate(response.data.data.expireDate);
            self.RoomName = response.data.data.roomName;
            self.CheckInStatus = response.data.data.checkinStatus;
            self.RequiresOtp = response.data.data.requiresOtp === true;
            self.MeetingLoaded = true;
            if (self.RequiresOtp && self.CheckInStatus !== true) {
              self.$nextTick(() => self.$refs.otpInput?.focus());
            }
          } else {
            self.EmptyMessage = response.data.message || "Meeting not found.";
          }
        })
        .catch(function (error) {
          self.EmptyMessage =
            error?.response?.data?.message ||
            error?.message ||
            "Meeting not found.";
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: self.EmptyMessage,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    checkInMeeting() {
      let self = this;
      if (self.RequiresOtp && self.Otp.length !== 6) return;
      let temp = {
        eventID: self.EventID,
      };
      if (self.RequiresOtp) temp.otp = self.Otp;
      self.LoadingDialog = true;
      axios
        .post(
          `${self.url}Calendar/${
            self.RequiresOtp
              ? "verifyExternalMeetingOtp"
              : "checkInMeetingOffice365ByEventID"
          }`,
          temp
        )
        .then(function (response) {
          if (response.data.status == 0) {
            self.CheckInStatus = true;
            Swal.fire({
              icon: "success",
              title: "Check In Successful",
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
            throw new Error(response.data.message || "Check in failed");
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text:
              error?.response?.data?.message ||
              error?.message ||
              "Check in failed",
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    updateOtp(value) {
      this.Otp = String(value || "")
        .replace(/\D/g, "")
        .slice(0, 6);
    },

    ChangeFormatDate(date) {
      if (!date) return null;
      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes;
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear() +
        "  " +
        strTime
      );
    },
  },
};
</script>
<style scoped>
.checkin-page,
.checkin-page * {
  box-sizing: border-box;
}

.checkin-page {
  display: flex;
  min-height: 100vh;
  justify-content: center;
  padding: 28px 24px;
  background: #f6f6f6;
  color: #333;
  font-family: Inter, sans-serif;
}

.checkin-shell {
  width: min(760px, 100%);
}

.checkin-header {
  display: flex;
  min-height: 78px;
  align-items: center;
  gap: 18px;
  padding: 8px 18px;
  border-radius: 40px;
  background: #fff;
  box-shadow: 0 4px 10px rgba(0, 55, 142, 0.08);
}

.checkin-logo {
  display: grid;
  width: 60px;
  height: 60px;
  flex: 0 0 60px;
  place-items: center;
  border-radius: 50%;
  background: #edf1f5;
}

.checkin-logo img {
  width: 39px;
  height: 39px;
  object-fit: contain;
}

.checkin-header h1 {
  margin: 0;
  color: #111;
  font-size: 25px;
  line-height: 30px;
}

.checkin-header small {
  color: #00378e;
  font-size: 13px;
}

.checkin-card {
  margin-top: 28px;
  overflow: hidden;
  border-radius: 20px !important;
  background: #fff;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.14) !important;
}

.checkin-card-title {
  display: flex;
  min-height: 68px;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-bottom: 1px solid #e4e7ef;
}

.checkin-card-title h2 {
  margin: 0;
  color: #00378e;
  font-size: 22px;
}

.checkin-content {
  padding: 30px !important;
}

.meeting-details {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.meeting-details article {
  display: flex;
  min-width: 0;
  min-height: 94px;
  flex-direction: column;
  justify-content: center;
  gap: 7px;
  padding: 16px 18px;
  border: 1px solid #e4e7ef;
  border-radius: 16px;
  background: #f8faff;
}

.meeting-details span {
  color: #67748a;
  font-size: 13px;
}

.meeting-details strong {
  color: #222;
  font-size: 16px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.checkin-button {
  display: flex;
  width: min(320px, 100%);
  height: 52px !important;
  margin: 30px auto 0;
  border-radius: 26px !important;
  color: #fff !important;
  font-size: 16px;
  text-transform: none;
}

.otp-section {
  width: min(360px, 100%);
  margin: 28px auto 0;
  text-align: center;
}

.otp-section label {
  display: block;
  margin-bottom: 12px;
  color: #27364d;
  font-size: 16px;
}

.otp-input ::v-deep input {
  color: #00378e;
  font-size: 30px;
  font-weight: 700;
  letter-spacing: 10px;
  text-align: center;
}

.checkin-empty {
  display: flex;
  min-height: 250px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: #333 !important;
  text-align: center;
}

.checkin-empty strong {
  font-size: 18px;
}

@media (max-width: 600px) {
  .checkin-page {
    align-items: flex-start;
    padding: 14px 12px 24px;
  }

  .checkin-header {
    min-height: 68px;
    gap: 12px;
    padding: 7px 10px;
    border-radius: 34px;
  }

  .checkin-logo {
    width: 54px;
    height: 54px;
    flex-basis: 54px;
  }

  .checkin-logo img {
    width: 35px;
    height: 35px;
  }

  .checkin-header h1 {
    font-size: 20px;
    line-height: 24px;
  }

  .checkin-header small {
    font-size: 12px;
  }

  .checkin-card {
    margin-top: 18px;
    border-radius: 16px !important;
  }

  .checkin-card-title {
    min-height: 60px;
  }

  .checkin-card-title h2 {
    font-size: 20px;
  }

  .checkin-content {
    padding: 18px 14px 22px !important;
  }

  .meeting-details {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .meeting-details article {
    min-height: 78px;
    padding: 13px 15px;
    border-radius: 14px;
  }

  .meeting-details strong {
    font-size: 15px;
  }

  .checkin-button {
    width: 100%;
    min-height: 48px;
    margin-top: 20px;
  }

  .checkin-empty {
    min-height: 220px;
    padding: 28px 18px !important;
  }
}

@media (max-width: 360px) {
  .checkin-header h1 {
    font-size: 18px;
  }

  .checkin-header small {
    display: none;
  }
}
</style>
